<template>
  <NewSecretGeneratedModal
    v-if="createdWebhookId"
    :webhook-id="createdWebhookId"
    @closed="emit('closed')"
  />
  <WebhookConfigModal
    v-else
    @webhook-created="handleWebhookCreated"
    @closed="handleConfigClosed"
  />
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';
import { ref } from 'vue';

// TODO: move these into pages/api/components once temp_api_controls is removed
import NewSecretGeneratedModal from '@/components/integrations/NewSecretGeneratedModal.vue';
import WebhookConfigModal from '@/components/integrations/WebhookConfigModal.vue';

const emit = defineEmits<{
  closed: [];
}>();

useHead({ title: 'Create Webhook - Webhooks - API - Crossbeam' });

const createdWebhookId = ref<string | null>(null);

function handleWebhookCreated({ webhookId }: { webhookId: string }) {
  createdWebhookId.value = webhookId;
}

/**
 * WebhookConfigModal closes itself after a successful create, so only treat
 * this as a cancel when no webhook came back.
 */
function handleConfigClosed() {
  if (!createdWebhookId.value) emit('closed');
}
</script>
